/**
 * Renders an arrow icon svg for dropdowns
*/
import React from 'react';

const ArrowIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="currentColor"
    >
      <path d="M12 15.071l4.243-4.243a1 1 0 0 0-1.414-1.414L12 12.243l-2.829-2.829a1 1 0 0 0-1.414 1.414L12 15.071z" />
    </svg>
  );
};

export default ArrowIcon;